<template>
		<div>
      <div id="page" style="min-height: 640px;">
        <ProfileHeader></ProfileHeader>
        <AdminFooter></AdminFooter>
        <div class="page-content" style="min-height: 640px;">
          <div class="card mb-0 preload-img" data-src="images/pictures/faces/default.png" data-card-height="65vh" style="height: 65vh; background-image: url(&quot;images/pictures/0l.jpg&quot;);">
            <div class="card-top">
              <h6 class="text-center mt-3 opacity-50 font-400"></h6>
            </div>
            <div class="card-bottom ml-3">
              <h1 class="font-40 line-height-xl">{{user.name}}</h1>
              <p class="pb-0 mb-0 font-12"><i class="fa fa-map-marker mr-2"></i>Joined: {{user.created_at}}</p>
              <p>
                {{ user.email }}
              </p>
            </div>
            <div class="card-overlay bg-gradient-fade-small"></div>
          </div>
          <div class="card card-style">
            <div class="content mb-0">
              <div class="row mb-0 text-center">
                <div class="col-6">
<!--                  <h1 class="mb-n1">{{user.farming_projects.length}}</h1>-->
                  <p class="font-10 mb-0 pb-0">Farming Projects</p>
                </div>
                <div class="col-6">
<!--                  <h1 class="mb-n1">{{user.stands.length}}</h1>-->
                  <p class="font-10 mb-0 pb-0">Stands</p>
                </div>
                <div class="col-6">
<!--                  <h1 class="mb-n1">{{user.investments.length}}</h1>-->
                  <p class="font-10 mb-0 pb-0">Investments</p>
                </div>
                <div class="col-6">
<!--                  <h1 class="mb-n1">{{user.rounds.length}}</h1>-->
                  <p class="font-10 mb-0 pb-0">Rounds</p>
                </div>
              </div>
              <div class="divider mb-4 mt-3"></div>
              <div class="row mb-0 pb-4">
                <div class="col-6">
                  <a @click="logout()" class="btn btn-s btn-full rounded-s bg-highlight text-uppercase font-900">Logout</a>
                </div>
                <div class="col-6">
                  <p @click="showPasswordFrom = true" class="btn btn-s btn-full rounded-s border-highlight color-highlight text-uppercase font-900">Change Password</p>
                </div>
              </div>
              <div v-if="showPasswordFrom" class="">
                <div class="input-style has-icon input-style-1 input-required pb-1">
                  <span>Password</span>
                  <em>(required)</em>
                  <input v-model="password" placeholder="Password" type="password">
                </div>

                <div class="input-style has-icon input-style-1 input-required pb-1">
                  <span>Confrim Password</span>
                  <em>(required)</em>
                  <input v-model="cpassword" placeholder="Confirm Password" type="password">
                </div>
                <p @click="saveNewPassword" class="btn btn-s btn-full rounded-s bg-highlight text-uppercase font-900">Save Changes</p>
              </div>
              <div v-else-if="Object.keys(response).length " class="alert-alert-success">
                
                <p>Password Changed Successfully</p>
              </div>
            </div>
          </div>
        </div>
        <div class="menu-hider"><div></div></div></div>
		</div>
</template>

<script>
    import global from "@/mixins/global";
    import ProfileHeader from "@/components/ProfileHeader";
    // import FooterBar from "@/components/FooterBar";
    import axios from "axios";
    import AdminFooter from "@/components/admin/AdminFooter";
    export default {
      mixins: [global],
      name: "AdminProfile",
      data(){
        return {
          showPasswordFrom: false,
          password: "",
          cpassword: "",
          response:{},
          error: {}
        }
      },
      components: {
        AdminFooter,
        ProfileHeader,
      },
      methods:{
        saveNewPassword(){
          axios.post(this.base_url+"password", {password: this.password}, this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{
            this.response = response
            this.showPasswordFrom = false
          }).catch(error=>{this.error = error})
        }
      }
    }
</script>

<style scoped>

</style>